'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import BacktestHistoryDashboard from './components/BacktestHistoryDashboard';

export default function BacktestHistoryPage() {
  return (
    <AppLayout>
      <BacktestHistoryDashboard />
    </AppLayout>
  );
}
